import * as React from "react";
import { Link } from "gatsby";

import Layout from "../../components/Layout";
import Seo from "../../components/Seo";

import Old2005BlogPage from "../../components/Old2005BlogPage";

const OldBlogPage = () => (
  <Layout>
    <Seo title="Old 2005 Blog—November 2008" />
	<Old2005BlogPage>
		<h2>November 2008</h2>



		<h3 className="blogdate">
		Monday, November 03, 2008
		</h3>






		<h4 className="blogitemtitle">
		It was great to be home!
		</h4>





		   <div className="blogitembody">
		   Back in New Zealand now, after my fantastic whirlwind visit in Canada, I must say it feels a bit weird to be here.  I truly had a blast in Canada, with my family in Kelowna and friends in Calgary, and with my shows in each location.  I topped the whole trip off with my good friend's wedding - what a great time, it was a reunion of friends for me, not just a celebration.  Oh, and I caught the bride's garter belt... yikes.<br /><br />Ah, Kelowna.  My brother brought his Nintendo Wii and we bowled the entire Thanksgiving weekend, hilarious.  My friend Kyle the Kiwi was able to join my family for Thanksgiving before returning to New Zealand, that was a treat.  A bit of a wrinkle at The Minstrel Cafe &amp; Bar - unfortunately I was double booked over another act, forcing me to play early during dinner.  I was disappointed; although it was out of my control, I apologize to anyone who was turned away due to the capacity dinner crowd.  Thanks for coming!  Also, too bad that I missed performances by Nat Jay and Adrian Glynn, who had the original show that night.  Finally, Ralph and George, it was great driving from Vancouver to Kelowna with you, thanks!<br /><br />Calgary.  My sinuses clogged, lips cracked, and face transformed into a cracked mud-bed.  I drank beer every night, which didn't help my reaction to the arid climate.  But I had a blast - I was overjoyed with the quantity of friends I was able to catch up with, and with the quality times we had.  And I met some great new people, too, which is always exciting.  Love those autumn leaves along the Bow.  Oh, I was very happy with my show at the Ironwood Stage &amp; Grill, thanks to everyone who came!  Much appreciation to Shelly Groves and Kodi Hutchinson for charming everyone with their violin and bass skills, too.  It was a real treat for me to experience Mark Berube and the Patriotic Few afterwards... awesome show!<br /><br />So, New Zealand.  It's a great place, truly.  I am here, it just takes a bit to get accustomed again.  A few weeks back home in Canada really made me feel... at home.  I look forward to being home again.  In the meantime... come visit??<br /><br />p.s.  Moon, don't think I'll forget you being the biggest that I've ever seen you, crawling up and out of the pink and blue over Calgary's "work stacks", near the end of another <span style={{fontStyle: "italic"}}>Greyhound Through the Rockies</span>.
		   </div>
		   <div className="blogitemfooter">
		   posted by Jesse @ 9:16 PM &nbsp;
		   </div>





		<p>
			<Link to="/blog2005/">Go back to the blog index page</Link>
		</p>
</Old2005BlogPage>
  </Layout>
)

export default OldBlogPage;
